import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { ApiModule } from '@sb/library/api';
import { AttachmentModule } from '@sb/library/attachment';
import { BannerModule } from '@sb/library/banner';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { FormFieldModule } from '@sb/library/form-field';
import { IconModule } from '@sb/library/icon';
import { LayoutModule } from '@sb/library/layout';
import { LocalizationModule } from '@sb/library/localization';
import { ProgressBarModule } from '@sb/library/progress-bar';
import { SubmissionBarModule } from '@sb/library/submission-bar';
import { UtilityModule } from '@sb/library/utility';
import { DialogUploadComponent } from './upload-dialog/upload-dialog.component';
import { UploadComponent } from './upload/upload.component';
import { DialogUploadingComponent } from './uploading-dialog/uploading-dialog.component';
import { A11yModule } from "@angular/cdk/a11y";
import { ClipboardModule } from '@sb/library/clipboard';

@NgModule({
    declarations: [
        UploadComponent,
        DialogUploadComponent,
        DialogUploadingComponent,
    ],
    imports: [
    CommonModule,
    ButtonModule,
    LayoutModule,
    AttachmentModule,
    IconModule,
    ApiModule,
    MatDividerModule,
    ProgressBarModule,
    LocalizationModule,
    BannerModule,
    FormFieldModule,
    UtilityModule,
    BaseModule,
    SubmissionBarModule,
    A11yModule,
    ClipboardModule
],
    exports: [
        UploadComponent,
        DialogUploadComponent,
        DialogUploadingComponent,
    ]
})
export class UploadModule { }
